import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { NgModule } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { SimplaexModalComponentNg2 } from './common/modal/ng2/SimplaexModalComponentNg2.ts';
import { ModalsHandlerServiceNg2 } from './common/modal/ng2/SimplaexModalsHandlerServiceNg2.ts';

import { NumberWidgetComponentNg2 } from './components/explore/widgets/numberWidgetNg2.ts';
import { TagCloudWidgetComponentNg2 } from './components/explore/widgets/tagCloudWidgetNg2.ts';
import { ExploreWidgetWrapperComponentNg2 } from './components/explore/widgets/exploreWidgetWrapperNg2.ts';
import { ImagesRowExploreWidgetComponentNg2 } from './components/explore/widgets/imagesRowExploreWidgetNg2.ts';
import { ExploreSnapshotWidgetsComponentNg2 } from './components/explore/exploreSnapshotWidgetsNg2.ts';
import { ExploreBreakdownModalContentWrapperDirective } from './components/explore/exploreBreakdownModalContentWrapperUpgraded.ts';
import { FormsModule } from '@angular/forms';
import { TagCloudModule } from 'angular-tag-cloud-module';

@NgModule({
  declarations: [
    NumberWidgetComponentNg2,
    TagCloudWidgetComponentNg2,
    ExploreWidgetWrapperComponentNg2,
    ImagesRowExploreWidgetComponentNg2,
    ExploreSnapshotWidgetsComponentNg2,
    ExploreBreakdownModalContentWrapperDirective,
    SimplaexModalComponentNg2
  ],
  // donwgraded components have to be declared as entry components
  // NOTE: here (https://github.com/angular/angular/issues/12965) they say:
  // If you are using upgrade/static then you should only move the AppComponent to the entryComponents and not put anything inside ngDoBootstrap.
  entryComponents: [
    ExploreWidgetWrapperComponentNg2,
    NumberWidgetComponentNg2,
    TagCloudWidgetComponentNg2,
    ImagesRowExploreWidgetComponentNg2,
    ExploreSnapshotWidgetsComponentNg2
  ],
  imports: [
    BrowserModule,
    UpgradeModule,
    FormsModule,
    TagCloudModule
  ],
  providers: [
    DecimalPipe,
    ModalsHandlerServiceNg2
  ],
  bootstrap: []
})

export default class Ng2AppModule {
  ngDoBootstrap() {
    // { strictDi: true } cannot be there until we solve dependency injection issues.
    //this.upgrade.bootstrap(document.body, ['nouislider']);
  }
}


/** WEBPACK FOOTER **
 ** ./src/angular2rootModule.js
 **/